export default __webpack_public_path__ + "static/media/experience.d1bef565.svg";